export default __webpack_public_path__ + "static/media/yellow-shocks.896a9463.svg";